import { render, staticRenderFns } from "./docBatchAdd.vue?vue&type=template&id=4829c29e&"
import script from "./docBatchAdd.vue?vue&type=script&lang=js&"
export * from "./docBatchAdd.vue?vue&type=script&lang=js&"
import style0 from "./docBatchAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports